<script setup lang="ts">
import { computed } from "vue";
import { useAnnouncer } from "@/composables/useAnnouncer";

const props = defineProps<{
  buildId: string | null;
}>();

const { announce } = useAnnouncer();

const disabled = computed<boolean>(() => props.buildId === null);

async function copy(): Promise<void> {
  if (!props.buildId) return;
  try {
    await navigator.clipboard.writeText(props.buildId);
    announce("copied");
  } catch {
    // Clipboard access can be denied by the browser (permissions, non-secure
    // context); there is nothing actionable to recover here for Phase 0.
  }
}
</script>

<template>
  <button
    type="button"
    class="rounded border border-brand-slate/40 bg-card px-2 py-1 font-mono text-xs text-brand-light focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-blue focus-visible:ring-offset-2 focus-visible:ring-offset-card disabled:cursor-not-allowed disabled:opacity-50"
    :disabled="disabled"
    :aria-label="buildId ? `Copy build id ${buildId}` : 'Build id unknown'"
    @click="copy"
  >
    {{ buildId ?? "unknown" }}
  </button>
</template>
